import React from 'react';
import { shape } from 'prop-types';
import endPoints from '../../config/endPoints';
import { StyledLyraCartItems } from './StyledCardCart';

function LyraCartItem(props) {
  const { cart: { title = '' } = {} } = props;
  return (
    <StyledLyraCartItems key={title}>
      <img
        src={endPoints.LYRA_GIFT_CARD.URL}
        alt={endPoints.LYRA_GIFT_CARD.ALT}
        className="pointer"
      />
      <div className="dec">
        <strong className="pointer"> {title}</strong>
      </div>
    </StyledLyraCartItems>
  );
}

LyraCartItem.propTypes = {
  cart: shape({}).isRequired,
};

export default LyraCartItem;



// WEBPACK FOOTER //
// client/containers/GiftCardCart/LyraCartItem.js